﻿export enum eBundle{
    app = "app",
    admin = "admin"
}

export class Dirs {
    public static component(name: string, bundle: eBundle = eBundle.app): string {
        return this.get(`html/${bundle}/${name}.component.html`);
    }

    public static template(name: string, bundle: eBundle = eBundle.app): string {
        return this.get(`html/${bundle}/${name}.html`);
    }

    public static view(name: string, bundle: eBundle = eBundle.app): string {
        return this.get(`html/${bundle}/${name}.view.html`);
    }

    public static get(url: string) {
        return (window as any).html[url];
    }
}
